import { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { Col, Form, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import LotacaoService from "../../services/LotacaoService";
import loadSCGif from "../../assets/load_SC.gif";
import { Lotacao } from "../../shared/interfaces/DadosFinanceirosInterface";
import { Label } from "../Label/styles";
import Button from "../Button/button";
import InputComponent from "../Input/input";
import SelectComponent from "../Select/select";
import {
  BlueTitle,
  LoadingGif,
  LoadingOverlay,
  ModalBody,
  ModalContainer,
  ModalContent,
  ModalFooter,
  ModalHeader,
  RequiredFields,
  TextError,
} from "../../shared/styles/global.styles";
import { TextAreaObservacao } from "../../pages/Contribuinte/MenuPages/DadosFinanceiros/dadosFinanceiro.styles";
import localPagamentoService from "../../services/LocalPagamentoService";
import { LocalPagamentoDto } from "../../shared/dtos/LocalPagamento.dto";
import {
  CreateDadosFinanceirosDto,
  GetDadosFinanceirosDto,
} from "../../shared/dtos/DadosFinanceiros.dto";
import dadosFinanceirosService from "../../services/DadosFinanceirosService";
import { IoCloseSharp } from "react-icons/io5";
import tipoExclusaoService from "../../services/TipoExclusaoService";
import { GetTipoExclusaoDTO } from "../../shared/dtos/TipoExclusao.dto";
import { GetContribuinteDto } from "../../shared/dtos/Contribuinte.dto";
import FichaFinanceiraService from "../../services/FichaFinanceiraService";
import instrucaoBancariaService from "../../services/InstrucaoBancariaService";
import { InstrucaoBancariaDto } from "../../shared/dtos/InstrucaoBancaria.dto";
import { TypeLayoutRemessaRetornoEnum } from "../../shared/enum/layoutRemessaRetorno.enum";
import {
  ContainerFormadioButton,
  ContainerRadioButton,
  MainContainerRadioButton,
} from "./dadosFinanceirosModal.styles";

interface DadosFinanceirosModalProps {
  show: boolean;
  onHide: () => void;
  contribuinteData: GetContribuinteDto;
  dadoFinanceiroToEdit?: GetDadosFinanceirosDto;
  lastDadoFinanceiro: GetDadosFinanceirosDto;
  setSelectedTab: React.Dispatch<React.SetStateAction<number>>;
  setCancelFutureInstallmentsIds: React.Dispatch<
    React.SetStateAction<number[]>
  >;
  newFlow: boolean;
  setNewFlow: React.Dispatch<React.SetStateAction<boolean>>;
  fetchDadosFinanceiros: () => Promise<void>;
  editOnly: boolean;
}

const DadosFinanceirosModal: React.FC<DadosFinanceirosModalProps> = ({
  show,
  onHide,
  contribuinteData,
  dadoFinanceiroToEdit,
  lastDadoFinanceiro,
  setSelectedTab,
  setCancelFutureInstallmentsIds,
  newFlow,
  setNewFlow,
  fetchDadosFinanceiros,
  editOnly,
}) => {
  const [dadoFinanceiro, setDadoFinanceiro] =
    useState<CreateDadosFinanceirosDto>({
      dataInclusao:
        lastDadoFinanceiro?.dataExclusao!.split("T")[0] ??
        contribuinteData.LastMovimentacao?.data_movimentacao.split("T")[0],
      localPagamento: null,
      bancoDebitoAutomatico: "",
      agenciaDebitoAutomatico: "",
      contaCorrenteDebitoAutomatico: "",
      acumulaPagamento: 0,
      frequenciaParcela: 1,
      valorTitular: "0,00",
      valorDependente: "0,00",
      dataExclusao: null,
      observacao: "",
      lotacao: undefined,
      chavePix: "",
      tipoExclusao: {
        id: 2,
        nome: "",
      },
      primeiraInstrucaoBancaria: undefined,
      segundaInstrucaoBancaria: undefined,
      terceiraInstrucaoBancaria: undefined,
      quartaInstrucaoBancaria: undefined,
    });
  const [locaisPagamento, setLocaisPagamento] = useState<LocalPagamentoDto[]>(
    []
  );
  const [tiposExclusao, setTiposExclusao] = useState<GetTipoExclusaoDTO[]>([]);
  const [lotacoes, setLotacoes] = useState<Lotacao[]>([]);
  const [instrucaoBancaria, setInstrucaoBancaria] = useState<
    InstrucaoBancariaDto[]
  >([]);
  const [isEdited, setIsEdited] = useState<boolean>(false);
  const [isRequest, setIsRequest] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [invalidFields, setInvalidFields] = useState<string[]>([]);

  // Estado para campos inválidos
  // const inputRefs = useRef<{
  //   [key: string]: HTMLInputElement | HTMLSelectElement | null;
  // }>({
  //   dataInclusao: null,
  //   localPagamento: null,
  //   acumulaPagamento: null,
  //   frequenciaParcela: null,
  //   valorTitular: null,
  //   valorDependente: null,
  //   dataExclusao: null,
  // });

  const fetchLocaisPagamento = async () => {
    try {
      const response = await localPagamentoService.getAllLocaisPagamento();
      setLocaisPagamento(response);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Erro ao buscar locais de pagamento",
      });
    }
  };

  const fetchTiposExclusao = async () => {
    try {
      const response = await tipoExclusaoService.getAll();
      setTiposExclusao(response);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Erro ao buscar tipos de exclusão",
      });
    }
  };

  const fetchLotacoes = async () => {
    try {
      const response = await LotacaoService.getAllLotacoes();
      setLotacoes(response);
    } catch (error) {
      Swal.fire({
        title: "Erro",
        text: "Erro ao buscar lotações. Por favor, tente novamente.",
        icon: "error",
        confirmButtonText: "Fechar",
        allowOutsideClick: false,
      });
    }
  };

  const fetchInstrucaoBancaria = async () => {
    try {
      const response = await instrucaoBancariaService.getAllInstrucaoBancaria();
      setInstrucaoBancaria(response);
    } catch (error) {
      Swal.fire({
        title: "Erro",
        text: "Erro ao buscar instruções bancárias. Por favor, tente novamente.",
        icon: "error",
        confirmButtonText: "Fechar",
        allowOutsideClick: false,
      });
    }
  };

  const fetchActiveInstallments = async (
    dataExclusao: string
  ): Promise<number[]> => {
    try {
      // Primeiro, buscar apenas o total de registros
      const firstResponse = await FichaFinanceiraService.searchParcela(
        contribuinteData.id,
        1,
        1
      );

      // Agora, buscar todas as parcelas usando `total`
      const response = await FichaFinanceiraService.searchParcela(
        contribuinteData.id,
        1,
        firstResponse.total
      );

      return response.data
        .filter(
          (parcela) =>
            parcela.statusParcela === "Ativa" &&
            new Date(parcela.dataVencimento) > new Date(dataExclusao)
        )
        .map((parcela) => parcela.id);
    } catch (error) {
      Swal.fire({
        title: "Erro",
        text: "Erro ao buscar parcelas. Por favor, tente novamente.",
        icon: "error",
        confirmButtonText: "Fechar",
        allowOutsideClick: false,
      });
      return [];
    }
  };

  // Função para formatar valores monetários
  const formatCurrency = (value: string) => {
    value = value.replace(/\D/g, ""); // Remove caracteres não numéricos
    value = (parseFloat(value) / 100).toFixed(2).replace(".", ","); // Formata como valor monetário
    return `R$ ${value.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`; // Adiciona separadores de milhar e "R$" no início
  };

  // Função para remover formatação
  // const unformatCurrency = (value: string): string => {
  //   return value.replace(/\D/g, "");
  // };

  // Função para atualizar os valores dos campos
  const handleChangeValues = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;

    // Aplica formatação monetária para valores específicos
    let formattedValue = value;
    if (["valorTitular", "valorDependente"].includes(name)) {
      formattedValue = formatCurrency(value);
    }

    setDadoFinanceiro({ ...dadoFinanceiro, [name]: formattedValue });
  };

  // Função para lidar com mudança no input de valor titular
  // const handleTitularChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   const value = e.target.value.replace(/[^\d]/g, "");

  //   if (!value) {
  //     setDadoFinanceiro((prev) => ({ ...prev, valorTitular: "" }));
  //     return;
  //   }

  //   // Converte para número mantendo os centavos
  //   const amount = value.padStart(3, "0");
  //   const reais = amount.slice(0, -2).replace(/^0+/, "") || "0";
  //   const centavos = amount.slice(-2);

  //   const formatted = `${reais},${centavos}`;
  //   setDadoFinanceiro((prev) => ({
  //     ...prev,
  //     valorTitular: formatted,
  //   }));
  //   clearError(e);
  // };

  // Função para lidar com mudança no input de valor dependente
  // const handleDependenteChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   const value = e.target.value.replace(/[^\d]/g, "");

  //   if (!value) {
  //     setDadoFinanceiro((prev) => ({ ...prev, valorDependente: "" }));
  //     return;
  //   }

  //   // Converte para número mantendo os centavos
  //   const amount = value.padStart(3, "0");
  //   const reais = amount.slice(0, -2).replace(/^0+/, "") || "0";
  //   const centavos = amount.slice(-2);

  //   const formatted = `${reais},${centavos}`;
  //   setDadoFinanceiro((prev) => ({
  //     ...prev,
  //     valorDependente: formatted,
  //   }));
  //   clearError(e);
  // };

  const formatarValorEmReais = (valor: string) => {
    if (!valor) return "R$ 0,00";

    // Se o valor já estiver no formato numérico com ponto como separador decimal, converte diretamente para número
    const numero = parseFloat(valor.replace(",", "."));

    // Verifica se o valor é um número válido
    if (isNaN(numero)) return "R$ 0,00";

    // Formata o número para reais com separadores corretos
    return numero.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  };

  const clearFieldsAndClose = () => {
    setIsEdited(false);
    setDadoFinanceiro({
      dataInclusao: contribuinteData.LastMovimentacao?.data_movimentacao
        ? contribuinteData.LastMovimentacao.data_movimentacao.split("T")[0]
        : "",
      localPagamento: null,
      bancoDebitoAutomatico: "",
      agenciaDebitoAutomatico: "",
      contaCorrenteDebitoAutomatico: "",
      acumulaPagamento: 0,
      frequenciaParcela: 1,
      valorTitular: "",
      valorDependente: "0,00",
      dataExclusao: null,
      observacao: "",
      lotacao: undefined,
      chavePix: "",
      tipoExclusao: {
        id: 2,
        nome: "",
      },
      primeiraInstrucaoBancaria: undefined,
      segundaInstrucaoBancaria: undefined,
      terceiraInstrucaoBancaria: undefined,
      quartaInstrucaoBancaria: undefined,
    });
    setInvalidFields([]);
    onHide();
    fetchDadosFinanceiros();
  };

  const clearError = (
    event:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLSelectElement>
  ) => {
    const { name } = event.target;

    setInvalidFields((prev) => prev.filter((field) => field !== name));
  };

  const handleSave = async () => {
    setIsRequest(true);
    setLoading(true);

    // Validação dos campos
    const newInvalidFields: string[] = [];

    if (!dadoFinanceiro.dataInclusao) {
      newInvalidFields.push("dataInclusao");
    } else if (
      !lastDadoFinanceiro &&
      contribuinteData.LastMovimentacao &&
      dadoFinanceiro.dataInclusao <
        contribuinteData.LastMovimentacao.data_movimentacao
    ) {
      newInvalidFields.push("dataInclusao");
    } else if (
      lastDadoFinanceiro &&
      lastDadoFinanceiro.dataExclusao &&
      dadoFinanceiro.dataInclusao < lastDadoFinanceiro.dataExclusao
    ) {
      newInvalidFields.push("dataInclusao");
    }
    // else if (
    //   dadoFinanceiro.dataInclusao > new Date().toISOString().split("T")[0]
    // ) {
    //   newInvalidFields.push("dataInclusao");
    // }

    if (
      dadoFinanceiro.dataExclusao &&
      dadoFinanceiro.dataExclusao < dadoFinanceiro.dataInclusao
    ) {
      newInvalidFields.push("dataExclusao");
    }
    // else if (
    //   dadoFinanceiro.dataExclusao &&
    //   dadoFinanceiro.dataExclusao > new Date().toISOString().split("T")[0]
    // ) {
    //   newInvalidFields.push("dataExclusao");
    // }

    if (!dadoFinanceiro.localPagamento) {
      newInvalidFields.push("localPagamento");
    } else {
      if (
        dadoFinanceiro.localPagamento.layoutRemessa &&
        dadoFinanceiro.localPagamento.layoutRemessa.type ===
          TypeLayoutRemessaRetornoEnum.DEBITO_AUTOMATICO
      ) {
        if (!dadoFinanceiro.bancoDebitoAutomatico) {
          newInvalidFields.push("bancoDebitoAutomatico");
        }
        if (!dadoFinanceiro.agenciaDebitoAutomatico) {
          newInvalidFields.push("agenciaDebitoAutomatico");
        }
        if (!dadoFinanceiro.contaCorrenteDebitoAutomatico) {
          newInvalidFields.push("contaCorrenteDebitoAutomatico");
        }
      }
    }

    if (
      !dadoFinanceiro.valorTitular ||
      dadoFinanceiro.valorTitular === "R$ 0,00"
    ) {
      newInvalidFields.push("valorTitular");
    }

    if (newInvalidFields.length > 0) {
      setInvalidFields(newInvalidFields);

      let errorMessage = "Por favor, preencha todos os campos obrigatórios.";

      switch (newInvalidFields[0]) {
        case "dataInclusao":
          if (!dadoFinanceiro.dataInclusao) {
            errorMessage = "A data de inclusão é obrigatória.";
          } else if (
            !lastDadoFinanceiro &&
            contribuinteData.LastMovimentacao &&
            dadoFinanceiro.dataInclusao <
              contribuinteData.LastMovimentacao.data_movimentacao
          ) {
            errorMessage =
              "A data de inclusão deve ser maior ou igual à data da última movimentação.";
          } else if (
            lastDadoFinanceiro &&
            lastDadoFinanceiro.dataExclusao &&
            dadoFinanceiro.dataInclusao < lastDadoFinanceiro.dataExclusao
          ) {
            errorMessage =
              "A data de inclusão deve ser maior que a data de exclusão do último dado financeiro.";
          }
          // else if (
          //   dadoFinanceiro.dataInclusao > new Date().toISOString().split("T")[0]
          // ) {
          //   errorMessage =
          //     "A data de inclusão não pode ser maior que a data atual.";
          // }
          break;
        case "dataExclusao":
          // if (
          //   dadoFinanceiro.dataExclusao &&
          //   dadoFinanceiro.dataExclusao > new Date().toISOString().split("T")[0]
          // ) {
          //   errorMessage =
          //     "A data de exclusão não pode ser maior que a data atual.";
          // } else
          if (
            dadoFinanceiro.dataExclusao &&
            dadoFinanceiro.dataExclusao < dadoFinanceiro.dataInclusao
          ) {
            errorMessage =
              "A data de exclusão deve ser maior que a data de inclusão.";
          }
          break;
        case "localPagamento":
          errorMessage = "O local de pagamento é obrigatório.";
          break;
        case "valorTitular":
          errorMessage =
            "O valor do titular é obrigatório e não pode ser R$ 0,00.";
          break;
      }

      Swal.fire({
        icon: "error",
        title: "Erro nos campos",
        text: errorMessage,
        confirmButtonText: "OK",
        allowOutsideClick: false,
      });

      setIsRequest(false);
      setLoading(false);
      return;
    }

    // Preparação dos dados para envio
    const dadosFinanceirosToSend: CreateDadosFinanceirosDto = {
      dataInclusao: dadoFinanceiro.dataInclusao,
      dataExclusao: dadoFinanceiro.dataExclusao || null,
      acumulaPagamento: Number(dadoFinanceiro.acumulaPagamento || 0),
      valorTitular:
        dadoFinanceiro.valorTitular
          ?.toString()
          .replace(/[^\d.,]/g, "")
          .replace(",", ".")
          .replace(".", ",") || "0,00",
      valorDependente:
        dadoFinanceiro.valorDependente
          ?.toString()
          .replace(/[^\d.,]/g, "")
          .replace(",", ".")
          .replace(".", ",") || "0,00",
      frequenciaParcela: Number(dadoFinanceiro.frequenciaParcela || 1),
      localPagamento: dadoFinanceiro.localPagamento,
      bancoDebitoAutomatico: dadoFinanceiro.bancoDebitoAutomatico || "",
      agenciaDebitoAutomatico: dadoFinanceiro.agenciaDebitoAutomatico || "",
      contaCorrenteDebitoAutomatico:
        dadoFinanceiro.contaCorrenteDebitoAutomatico || "",
      chavePix: dadoFinanceiro.chavePix || "",
      lotacao: dadoFinanceiro.lotacao,
      observacao: dadoFinanceiro.observacao || "",
      imprimir: dadoFinanceiro.imprimir || false,
      remessa: dadoFinanceiro.remessa || false,
      tipoExclusao:
        dadoFinanceiro.dataExclusao !== null
          ? dadoFinanceiro.tipoExclusao
          : undefined,
      primeiraInstrucaoBancaria: dadoFinanceiro.primeiraInstrucaoBancaria,
      segundaInstrucaoBancaria: dadoFinanceiro.segundaInstrucaoBancaria,
      terceiraInstrucaoBancaria: dadoFinanceiro.terceiraInstrucaoBancaria,
      quartaInstrucaoBancaria: dadoFinanceiro.quartaInstrucaoBancaria,
    };
    let response;
    if (dadoFinanceiroToEdit?.id) {
      await dadosFinanceirosService
        .updateDadosFinanceiros(dadoFinanceiroToEdit.id, dadosFinanceirosToSend)
        .then((res) => {
          response = res;
        })
        .catch((error) => {
          console.error("Erro ao atualizar dado financeiro:", error);
          Swal.fire({
            icon: "error",
            title: "Erro ao atualizar dado financeiro",
            text: error.message || "Por favor, tente novamente.",
            confirmButtonText: "Fechar",
            allowOutsideClick: false,
          });
          setIsRequest(false);
          setLoading(false);
          return;
        });
    } else {
      await dadosFinanceirosService
        .createDadosFinanceiros(dadosFinanceirosToSend, contribuinteData.id)
        .then((res) => {
          response = res;
        })
        .catch((error) => {
          console.error("Erro ao cadastrar dado financeiro:", error);
          Swal.fire({
            icon: "error",
            title: "Erro ao cadastrar dado financeiro",
            text: "Por favor, tente novamente.",
            confirmButtonText: "Fechar",
            allowOutsideClick: false,
          });
          setIsRequest(false);
          setLoading(false);
          return;
        });
    }

    if (response) {
      // Lógica para outros tipos de movimentação
      if (newFlow) {
        const result = await Swal.fire({
          title: "Dados Financeiros criados com sucesso.",
          icon: "success",
          showCancelButton: false,
          confirmButtonText: "Ok",
          allowOutsideClick: false,
        });

        if (result.isConfirmed) {
          const { value: result } = await Swal.fire({
            title: "Deseja seguir para a Ficha Financeira?",
            icon: "question",
            html: `
                      <button id="swal-confirm" class="swal2-confirm swal2-styled">
                        Sim!
                      </button>
                      <button id="swal-cancel" class="swal2-deny swal2-styled">
                        Não, finalizar cadastro!
                      </button>
                    `,
            customClass: {
              actions: "swal2-actions-column", // Coloca os botões em coluna
            },
            showConfirmButton: false,
            showCancelButton: false,
            focusConfirm: false,
            allowOutsideClick: false,
            didOpen: () => {
              // Adiciona eventos de clique aos botões personalizados
              const confirmButton = document.getElementById("swal-confirm");
              const cancelButton = document.getElementById("swal-cancel");

              if (confirmButton) {
                confirmButton.addEventListener("click", () => {
                  Swal.close(); // Fecha o modal
                  fetchDadosFinanceiros();
                  setIsRequest(false);
                  setLoading(false);
                  setSelectedTab(4); // Navega para a aba de cadastro de dependentes
                  setNewFlow(false);
                });
              }

              if (cancelButton) {
                cancelButton.addEventListener("click", () => {
                  Swal.close(); // Fecha o modal
                  fetchDadosFinanceiros();
                  setIsRequest(false);
                  setLoading(false);
                  setSelectedTab(0); // Navega para a aba de cadastro de dependentes
                  setNewFlow(false);
                });
              }
            },
          });
        }
      } else {
        // Verifica se a movimentação foi uma exclusão
        if (dadoFinanceiro.dataExclusao) {
          const result = await Swal.fire({
            title: "Sucesso",
            text: "Dado financeiro excluído!",
            icon: "success",
            confirmButtonText: "OK",
            allowOutsideClick: false,
          });
          if (dadoFinanceiro.dataExclusao) {
            const installmentsIds = await fetchActiveInstallments(
              dadoFinanceiro.dataExclusao
            );

            if (result.isConfirmed && installmentsIds.length > 0) {
              const { value: cancelFutureInstallments } = await Swal.fire({
                title: "Cancelar parcelas futuras?",
                text: `Deseja cancelar as parcelas futuras, a partir da data de exclusão ${
                  dadoFinanceiro.dataExclusao
                    ? new Date(dadoFinanceiro.dataExclusao).toLocaleDateString(
                        "pt-BR",
                        {
                          timeZone: "UTC",
                        }
                      )
                    : ""
                }?`,
                icon: "question",
                showCancelButton: true,
                confirmButtonText: "Sim",
                cancelButtonText: "Não",
                allowOutsideClick: false,
              });

              if (cancelFutureInstallments) {
                setSelectedTab(4);
                setCancelFutureInstallmentsIds(installmentsIds);
                await FichaFinanceiraService.cancelInstallments(installmentsIds, dadoFinanceiro.tipoExclusao!.id);

              }
            }
          }
        } else {
          // Alerta de sucesso para movimentações que não sejam exclusões
          await Swal.fire({
            title: "Sucesso",
            text: `Dados Financeiros ${
              dadoFinanceiroToEdit ? "atualizados" : "criados"
            } com sucesso!`,
            icon: "success",
            confirmButtonText: "OK",
            allowOutsideClick: false,
          });
        }
        clearFieldsAndClose();
        fetchDadosFinanceiros();
        setIsRequest(false);
        setLoading(false);
      }
    }
  };

  const loadDataEdit = async () => {
    if (dadoFinanceiroToEdit) {
      setDadoFinanceiro({
        id: dadoFinanceiroToEdit.id,
        dataInclusao: dadoFinanceiroToEdit.dataInclusao.split("T")[0],
        localPagamento: dadoFinanceiroToEdit.localPagamento || null,
        bancoDebitoAutomatico: dadoFinanceiroToEdit.bancoDebitoAutomatico || "",
        agenciaDebitoAutomatico:
          dadoFinanceiroToEdit.agenciaDebitoAutomatico || "",
        contaCorrenteDebitoAutomatico:
          dadoFinanceiroToEdit.contaCorrenteDebitoAutomatico || "",
        acumulaPagamento: dadoFinanceiroToEdit.acumulaPagamento || 0,
        frequenciaParcela: dadoFinanceiroToEdit.frequenciaParcela || 1,
        valorTitular: formatarValorEmReais(
          dadoFinanceiroToEdit.valorTitular || "0,00"
        ),
        valorDependente: formatarValorEmReais(
          dadoFinanceiroToEdit.valorDependente || "0,00"
        ),
        dataExclusao: dadoFinanceiroToEdit.dataExclusao
          ? dadoFinanceiroToEdit.dataExclusao.split("T")[0]
          : null,
        observacao: dadoFinanceiroToEdit.observacao || "",
        lotacao: dadoFinanceiroToEdit.lotacao,
        imprimir: dadoFinanceiroToEdit.imprimir,
        remessa: dadoFinanceiroToEdit.remessa,
        chavePix: dadoFinanceiroToEdit.chavePix || "",
        tipoExclusao: dadoFinanceiroToEdit.tipoExclusao || {
          id: 2,
          nome: "",
        },
        primeiraInstrucaoBancaria:
          dadoFinanceiroToEdit.primeiraInstrucaoBancaria,
        segundaInstrucaoBancaria: dadoFinanceiroToEdit.segundaInstrucaoBancaria,
        terceiraInstrucaoBancaria:
          dadoFinanceiroToEdit.terceiraInstrucaoBancaria,
        quartaInstrucaoBancaria: dadoFinanceiroToEdit.quartaInstrucaoBancaria,
      });
    }
    if (isEdited) {
      setIsEdited(false);
    }
    if (lastDadoFinanceiro && !dadoFinanceiroToEdit) {
      setDadoFinanceiro({
        dataInclusao: lastDadoFinanceiro.dataExclusao!.split("T")[0],
        valorTitular: "",
        valorDependente: "",
        observacao: "",
        tipoExclusao: { id: 2, nome: "" },
        localPagamento: null,
        bancoDebitoAutomatico: "",
        agenciaDebitoAutomatico: "",
        contaCorrenteDebitoAutomatico: "",
        acumulaPagamento: 0,
        frequenciaParcela: 1,
        imprimir: false,
        remessa: false,
        chavePix: "",
        dataExclusao: null,
      });
    }
  };

  useEffect(() => {
    loadDataEdit();
  }, [dadoFinanceiroToEdit, lastDadoFinanceiro]);

  useEffect(() => {
    fetchLocaisPagamento();
    fetchTiposExclusao();
    fetchLotacoes();
    fetchInstrucaoBancaria();
  }, []);

  return (
    <ModalContainer show={show}>
      <ModalContent width={95}>
        {loading && (
          <LoadingOverlay>
            <LoadingGif src={loadSCGif} alt="Carregando..." />
          </LoadingOverlay>
        )}

        <Button
          type="button"
          schemaButton="x-close"
          action={clearFieldsAndClose}
          icon={<IoCloseSharp size={30} />}
          position="absolute"
          top={10}
          right={10}
        />
        <ModalHeader>
          <BlueTitle>Dados Financeiros</BlueTitle>
        </ModalHeader>

        <ModalBody>
          <RequiredFields>
            (*) Indicativos de campos obrigatórios
          </RequiredFields>
          <Row>
            {/* 'g-2' diminui o espaço entre as colunas */}
            <Col sm>
              <Label htmlFor="dataInclusao">
                Data de Inclusão <TextError>*</TextError>
              </Label>
              <InputComponent
                type="date"
                name="dataInclusao"
                id="dataInclusao"
                color="primary"
                placeholder="Data de Inclusão"
                width={Number("100%")}
                value={dadoFinanceiro.dataInclusao}
                onChange={(e) => {
                  setDadoFinanceiro({
                    ...dadoFinanceiro,
                    dataInclusao: e.target.value,
                  });
                  clearError(e);
                }}
                min={
                  lastDadoFinanceiro?.dataExclusao ??
                  contribuinteData.LastMovimentacao?.data_movimentacao
                }
                // max={new Date().toISOString().split("T")[0]}
                errorMessage={
                  invalidFields.includes("dataInclusao")
                    ? "Data de inclusão inválida"
                    : ""
                }
                disabled={(!isEdited && !!dadoFinanceiroToEdit) || isRequest}
              />
            </Col>
            {!!dadoFinanceiroToEdit && (
              <>
                <Col sm>
                  <Label htmlFor="dataExclusao">Data de Exclusão</Label>
                  <InputComponent
                    type="date"
                    name="dataExclusao"
                    id="dataExclusao"
                    color="primary"
                    placeholder="Data de Exclusão"
                    width={Number("100%")}
                    value={dadoFinanceiro.dataExclusao || ""}
                    onChange={(e) => {
                      setDadoFinanceiro({
                        ...dadoFinanceiro,
                        dataExclusao: e.target.value || null,
                      });
                      clearError(e);
                    }}
                    min={dadoFinanceiro.dataInclusao || ""}
                    max={new Date().toISOString().split("T")[0]}
                    errorMessage={
                      invalidFields.includes("dataExclusao")
                        ? "Data de exclusão inválida"
                        : ""
                    }
                    disabled={
                      !(!!dadoFinanceiroToEdit && isEdited) || isRequest
                    }
                  />
                </Col>

                <Col sm>
                  <Label htmlFor="tipoExclusao">Tipo de Exclusão</Label>
                  <SelectComponent
                    color="black"
                    placeholder={
                      !dadoFinanceiro.dataExclusao
                        ? "Preencha a data de exclusão"
                        : ""
                    }
                    id="tipoExclusao"
                    width={Number("100%")}
                    name="tipoExclusao"
                    value={
                      !dadoFinanceiro.dataExclusao
                        ? ""
                        : dadoFinanceiro.tipoExclusao
                        ? dadoFinanceiro.tipoExclusao.id.toString()
                        : "2"
                    }
                    onChange={(e) => {
                      const selectedTipoExclusao = tiposExclusao.find(
                        (tipo) => tipo.id === parseInt(e.target.value)
                      );
                      setDadoFinanceiro({
                        ...dadoFinanceiro,
                        tipoExclusao:
                          selectedTipoExclusao &&
                          selectedTipoExclusao.id !== undefined
                            ? {
                                id: selectedTipoExclusao.id,
                                nome: selectedTipoExclusao.nome,
                              }
                            : undefined,
                      });
                      clearError(e);
                    }}
                    options={tiposExclusao
                      .map((tipo) => ({
                        value: tipo.id!.toString(),
                        label: tipo.nome,
                      }))
                      .filter((option) => option.value !== "0")}
                    disabled={
                      !dadoFinanceiro.dataExclusao ||
                      !(!!dadoFinanceiroToEdit && isEdited) ||
                      isRequest
                    }
                  />
                </Col>
              </>
            )}
            <Col sm>
              <Label htmlFor="localPagamento">
                Local de Pagamento <TextError>*</TextError>
              </Label>
              <SelectComponent
                color="black"
                placeholder="Selecione"
                id="localPagamento"
                width={Number("100%")}
                name="localPagamento"
                disabled={(!isEdited && !!dadoFinanceiroToEdit) || isRequest}
                value={dadoFinanceiro.localPagamento?.id?.toString() ?? ""}
                onChange={(e) => {
                  const selectedLocal = locaisPagamento.find(
                    (local) => local.id === parseInt(e.target.value)
                  );
                  setDadoFinanceiro({
                    ...dadoFinanceiro,
                    localPagamento:
                      selectedLocal && selectedLocal.id !== undefined
                        ? {
                            id: selectedLocal.id,
                            descricao: selectedLocal.descricao,
                            layoutRemessa: selectedLocal.layoutRemessa,
                          }
                        : null,
                    bancoDebitoAutomatico:
                      selectedLocal?.banco?.toString() ?? "",
                    agenciaDebitoAutomatico:
                      dadoFinanceiroToEdit?.agenciaDebitoAutomatico?.toString() ??
                      "",
                    contaCorrenteDebitoAutomatico:
                      dadoFinanceiroToEdit?.contaCorrenteDebitoAutomatico?.toString() ??
                      "",
                    imprimir: selectedLocal?.imprimirDocs ?? false,
                    remessa: selectedLocal?.imprimirDocs ?? false,
                  });
                  clearError(e);
                }}
                options={locaisPagamento.map((local) => ({
                  value: local.id!.toString(),
                  label: local.descricao,
                }))}
                errorMessage={
                  invalidFields.includes("localPagamento")
                    ? "A seleção do local de pagamento é obrigatória"
                    : ""
                }
              />
            </Col>
          </Row>
          {(!dadoFinanceiro.localPagamento ||
            !dadoFinanceiro.localPagamento.layoutRemessa ||
            dadoFinanceiro.localPagamento.layoutRemessa.type ===
              TypeLayoutRemessaRetornoEnum.DEBITO_AUTOMATICO) && (
            <>
              <Row>
                <Col sm>
                  <Label htmlFor="bancoDebitoAutomatico">
                    Banco Débito Automático{" "}
                    {dadoFinanceiro.localPagamento &&
                      dadoFinanceiro.localPagamento.layoutRemessa &&
                      dadoFinanceiro.localPagamento.layoutRemessa.type ===
                        TypeLayoutRemessaRetornoEnum.DEBITO_AUTOMATICO && (
                        <TextError>*</TextError>
                      )}
                  </Label>
                  <InputComponent
                    type="text"
                    name="bancoDebitoAutomatico"
                    id="bancoDebitoAutomatico"
                    value={dadoFinanceiro.bancoDebitoAutomatico ?? ""}
                    onChange={(e) =>
                      setDadoFinanceiro({
                        ...dadoFinanceiro,
                        bancoDebitoAutomatico: e.target.value,
                      })
                    }
                    placeholder="Débito automático"
                    disabled={
                      (!isEdited && !!dadoFinanceiroToEdit) || isRequest
                    }
                    color="black"
                    width={Number("100%")}
                    errorMessage={
                      invalidFields.includes("bancoDebitoAutomatico")
                        ? "Campo obrigatório"
                        : ""
                    }
                  />
                </Col>

                <Col sm>
                  <Label htmlFor="agenciaDebitoAutomatico">
                    Agência Débito Automático
                    {dadoFinanceiro.localPagamento &&
                      dadoFinanceiro.localPagamento.layoutRemessa &&
                      dadoFinanceiro.localPagamento.layoutRemessa.type ===
                        TypeLayoutRemessaRetornoEnum.DEBITO_AUTOMATICO && (
                        <TextError>*</TextError>
                      )}
                  </Label>
                  <InputComponent
                    type="text"
                    name="agenciaDebitoAutomatico"
                    id="agenciaDebitoAutomatico"
                    value={dadoFinanceiro.agenciaDebitoAutomatico ?? ""}
                    onChange={(e) =>
                      setDadoFinanceiro({
                        ...dadoFinanceiro,
                        agenciaDebitoAutomatico: e.target.value,
                      })
                    }
                    placeholder="Agência"
                    disabled={
                      (!isEdited && !!dadoFinanceiroToEdit) || isRequest
                    }
                    color="black"
                    width={Number("100%")}
                    errorMessage={
                      invalidFields.includes("agenciaDebitoAutomatico")
                        ? "Campo obrigatório"
                        : ""
                    }
                  />
                </Col>

                <Col sm>
                  <Label
                    htmlFor="contaCorrenteDebitoAutomatico"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    C.C. Débito Automático
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip id="tooltip-cc">
                          Conta Corrente Débito Automático
                        </Tooltip>
                      }
                    >
                      <i
                        className="fas fa-info-circle"
                        style={{ cursor: "help" }}
                      ></i>
                    </OverlayTrigger>
                    {dadoFinanceiro.localPagamento &&
                      dadoFinanceiro.localPagamento.layoutRemessa &&
                      dadoFinanceiro.localPagamento.layoutRemessa.type ===
                        TypeLayoutRemessaRetornoEnum.DEBITO_AUTOMATICO && (
                        <TextError>*</TextError>
                      )}
                  </Label>
                  <InputComponent
                    type="text"
                    name="contaCorrenteDebitoAutomatico"
                    id="contaCorrenteDebitoAutomatico"
                    value={dadoFinanceiro.contaCorrenteDebitoAutomatico ?? ""}
                    onChange={(e) =>
                      setDadoFinanceiro({
                        ...dadoFinanceiro,
                        contaCorrenteDebitoAutomatico: e.target.value,
                      })
                    }
                    placeholder="Conta corrente"
                    disabled={
                      (!isEdited && !!dadoFinanceiroToEdit) || isRequest
                    }
                    color="black"
                    width={Number("100%")}
                    errorMessage={
                      invalidFields.includes("contaCorrenteDebitoAutomatico")
                        ? "Campo obrigatório"
                        : ""
                    }
                  />
                </Col>

                <Col sm>
                  <Label htmlFor="chavePix">Chave Pix</Label>
                  <InputComponent
                    type="text"
                    name="chavePix"
                    id="chavePix"
                    value={dadoFinanceiro.chavePix ?? ""}
                    onChange={(e) =>
                      setDadoFinanceiro({
                        ...dadoFinanceiro,
                        chavePix: e.target.value,
                      })
                    }
                    placeholder="CPF/CNPJ, celular, e-mail ou aleatória"
                    disabled={
                      (!isEdited && !!dadoFinanceiroToEdit) || isRequest
                    }
                    color="black"
                    width={Number("100%")}
                  />
                </Col>
              </Row>
            </>
          )}
          <Row>
            <Col sm>
              <Label htmlFor="acumulaPagamento">Acúmulo de Pagamento (em dias)</Label>
              <InputComponent
                name="acumulaPagamento"
                id="acumulaPagamento"
                value={dadoFinanceiro.acumulaPagamento?.toString() ?? ""}
                onChange={(e) =>
                  setDadoFinanceiro({
                    ...dadoFinanceiro,
                    acumulaPagamento: Number(e.target.value.replace(/\D/g, "")),
                  })
                }
                placeholder="Acúmulo de pagamento"
                disabled={(!isEdited && !!dadoFinanceiroToEdit) || isRequest}
                color="black"
                width={Number("100%")}
                min="1"
              />
            </Col>
            <Col sm>
              <Label htmlFor="frequenciaParcela">
                Frequência de Parcelas <TextError>*</TextError>
              </Label>
              <SelectComponent
                name="frequenciaParcela"
                id="frequenciaParcela"
                value={dadoFinanceiro.frequenciaParcela?.toString() ?? "1"}
                onChange={(e) => {
                  setDadoFinanceiro({
                    ...dadoFinanceiro,
                    frequenciaParcela: Number(e.target.value),
                  });
                  clearError(e);
                }}
                placeholder="Selecione"
                disabled={(!isEdited && !!dadoFinanceiroToEdit) || isRequest}
                color="black"
                width={Number("100%")}
                options={Array.from({ length: 12 }, (_, i) => ({
                  value: (i + 1).toString(),
                  label: `${i + 1}`,
                }))}
                errorMessage={
                  invalidFields.includes("frequenciaParcela")
                    ? "Preencha o campo frequência de parcelas"
                    : ""
                }
              />
            </Col>
            <Col sm>
              <Label htmlFor="valorTitular">
                Valor para Titular <TextError>*</TextError>
              </Label>
              <InputComponent
                name="valorTitular"
                id="valorTitular"
                value={dadoFinanceiro.valorTitular || ""}
                onChange={(e) => {
                  handleChangeValues(e);
                  clearError(e);
                }}
                placeholder="R$ 0,00"
                disabled={(!isEdited && !!dadoFinanceiroToEdit) || isRequest}
                color="black"
                width={Number("100%")}
                errorMessage={
                  invalidFields.includes("valorTitular")
                    ? "Preencha o campo valor para titular"
                    : ""
                }
              />
            </Col>
            <Col sm>
              <Label htmlFor="valorDependente">
                Valor por Dependente <TextError>*</TextError>
              </Label>
              <InputComponent
                name="valorDependente"
                id="valorDependente"
                value={dadoFinanceiro.valorDependente || ""}
                onChange={(e) => {
                  handleChangeValues(e);
                  clearError(e);
                }}
                placeholder="R$ 0,00"
                disabled={(!isEdited && !!dadoFinanceiroToEdit) || isRequest}
                color="black"
                width={Number("100%")}
                errorMessage={
                  invalidFields.includes("valorDependente")
                    ? "Preencha o campo valor por dependente"
                    : ""
                }
              />
            </Col>
          </Row> 
          
          <Row>
            <Col>
              <Label htmlFor="lotacao">Lotação</Label>
              <SelectComponent
                color="black" // Cor do texto, você pode personalizar
                placeholder="Sem lotação"
                isPlaceHolder={!isEdited}
                id="lotacao"
                width={Number("100%")}
                name="lotacao"
                value={
                  dadoFinanceiro.lotacao
                    ? dadoFinanceiro.lotacao.id.toString()
                    : ""
                }
                onChange={(e) => {
                  if (e.target.value === "") {
                    // Handle case when "Selecionar uma lotação" is selected
                    setDadoFinanceiro({
                      ...dadoFinanceiro,
                      lotacao: undefined,
                    });
                  } else {
                    const selectedLotacao = lotacoes.find(
                      (l) => l.id === parseInt(e.target.value)
                    );
                    if (selectedLotacao) {
                      setDadoFinanceiro({
                        ...dadoFinanceiro,
                        lotacao: {
                          id: selectedLotacao.id!,
                          descricao: selectedLotacao.descricao,
                        },
                      });
                    }
                  }
                }}
                disabled={(!isEdited && !!dadoFinanceiroToEdit) || isRequest}
                options={lotacoes.map((l) => ({
                  value: (l.id ?? "").toString(),
                  label: l.descricao,
                }))}
              />
            </Col>

            <Col>
              <MainContainerRadioButton>
                <div>
                  <Label htmlFor="imprimir">
                    Imprimir <TextError>*</TextError>
                  </Label>
                  <Form>
                    {["radio"].map((type) => (
                      <ContainerRadioButton key={`inline-${type}`}>
                        <Form.Check
                          inline
                          label="Sim"
                          name="imprimir"
                          type="radio"
                          id={`inline-${type}-1`}
                          value="true"
                          checked={dadoFinanceiro.imprimir === true}
                          onChange={(e) => {
                            setDadoFinanceiro((prev) => ({
                              ...prev,
                              imprimir: true,
                            }));
                            clearError(e);
                          }}
                          disabled={
                            (!isEdited && !!dadoFinanceiroToEdit) || isRequest
                          }
                        />
                        <Form.Check
                          inline
                          label="Não"
                          name="imprimir"
                          type="radio"
                          id={`inline-${type}-2`}
                          value="false"
                          checked={dadoFinanceiro.imprimir === false}
                          onChange={(e) => {
                            setDadoFinanceiro((prev) => ({
                              ...prev,
                              imprimir: false,
                            }));
                            clearError(e);
                          }}
                          disabled={
                            (!isEdited && !!dadoFinanceiroToEdit) || isRequest
                          }
                        />
                      </ContainerRadioButton>
                    ))}
                  </Form>

                  {invalidFields.includes("imprimir") && (
                    <TextError>A seleção de imprimir é obrigatória.</TextError>
                  )}
                </div>
                <ContainerFormadioButton>
                  <Label htmlFor="imprimir">
                    Gerar remessa <TextError>*</TextError>
                  </Label>
                  <Form>
                    {["radio"].map((type) => (
                      <ContainerRadioButton key={`inline-${type}`}>
                        <Form.Check
                          inline
                          label="Sim"
                          name="remessa"
                          type="radio"
                          id={`inline-${type}-1`}
                          value="true"
                          disabled={
                            (!isEdited && !!dadoFinanceiroToEdit) || isRequest
                          }
                          checked={dadoFinanceiro.remessa === true}
                          onChange={(e) => {
                            setDadoFinanceiro((prev) => ({
                              ...prev,
                              remessa: true,
                            }));
                            clearError(e);
                          }}
                        />
                        <Form.Check
                          inline
                          label="Não"
                          name="remessa"
                          type="radio"
                          id={`inline-${type}-2`}
                          value="false"
                          checked={dadoFinanceiro.remessa === false}
                          onChange={(e) => {
                            setDadoFinanceiro((prev) => ({
                              ...prev,
                              remessa: false,
                            }));
                            clearError(e);
                          }}
                          disabled={
                            (!isEdited && !!dadoFinanceiroToEdit) || isRequest
                          }
                        />
                      </ContainerRadioButton>
                    ))}
                  </Form>

                  {invalidFields.includes("remessa") && (
                    <TextError>
                      A seleção de gerar remessa é obrigatória.
                    </TextError>
                  )}
                </ContainerFormadioButton>
              </MainContainerRadioButton>
            </Col>
          </Row>
          <Row>
            <Col>
              <Label htmlFor="primeiraInstrucaoBancaria">
                Instrução bancária
              </Label>
              <SelectComponent
                color="black"
                placeholder="Nenhuma instrução bancária"
                isPlaceHolder={!isEdited}
                id="primeiraInstrucaoBancaria"
                width={Number("100%")}
                name="primeiraInstrucaoBancaria"
                value={
                  dadoFinanceiro.primeiraInstrucaoBancaria?.id
                    ? dadoFinanceiro.primeiraInstrucaoBancaria.id.toString()
                    : ""
                }
                onChange={(e) => {
                  if (e.target.value === "") {
                    setDadoFinanceiro({
                      ...dadoFinanceiro,
                      primeiraInstrucaoBancaria: undefined,
                    });
                  } else {
                    const selectedInstrucao = instrucaoBancaria.find(
                      (instrucao) => instrucao.id === parseInt(e.target.value)
                    );
                    if (selectedInstrucao) {
                      setDadoFinanceiro({
                        ...dadoFinanceiro,
                        primeiraInstrucaoBancaria: selectedInstrucao,
                      });
                    }
                  }
                }}
                disabled={(!isEdited && !!dadoFinanceiroToEdit) || isRequest}
                options={instrucaoBancaria.map((instrucao) => ({
                  value: (instrucao.id ?? "").toString(),
                  label: instrucao.tipoInstrucao,
                }))}
              />
            </Col>
          </Row>
          {/* 
          <Row>
            <Col>
              <Label htmlFor="primeiraInstrucaoBancaria">
                Primeira Instrução bancária
              </Label>
              <SelectComponent
                color="black"
                placeholder="Nenhuma instrução bancária"
                isPlaceHolder={!isEdited}
                id="primeiraInstrucaoBancaria"
                width={Number("100%")}
                name="primeiraInstrucaoBancaria"
                value={
                  dadoFinanceiro.primeiraInstrucaoBancaria?.id
                    ? dadoFinanceiro.primeiraInstrucaoBancaria.id.toString()
                    : ""
                }
                onChange={(e) => {
                  if (e.target.value === "") {
                    setDadoFinanceiro({
                      ...dadoFinanceiro,
                      primeiraInstrucaoBancaria: undefined,
                    });
                  } else {
                    const selectedInstrucao = instrucaoBancaria.find(
                      (instrucao) => instrucao.id === parseInt(e.target.value)
                    );
                    if (selectedInstrucao) {
                      setDadoFinanceiro({
                        ...dadoFinanceiro,
                        primeiraInstrucaoBancaria: selectedInstrucao,
                      });
                    }
                  }
                }}
                disabled={(!isEdited && !!dadoFinanceiroToEdit) || isRequest}
                options={instrucaoBancaria.map((instrucao) => ({
                  value: (instrucao.id ?? "").toString(),
                  label: instrucao.tipoInstrucao,
                }))}
              />
            </Col>
            <Col>
              <Label htmlFor="segundaInstrucaoBancaria">
                Segunda Instrução bancária
              </Label>
              <SelectComponent
                color="black"
                placeholder="Nenhuma instrução bancária"
                isPlaceHolder={!isEdited}
                id="segundaInstrucaoBancaria"
                width={Number("100%")}
                name="segundaInstrucaoBancaria"
                value={
                  dadoFinanceiro.segundaInstrucaoBancaria?.id
                    ? dadoFinanceiro.segundaInstrucaoBancaria.id.toString()
                    : ""
                }
                onChange={(e) => {
                  if (e.target.value === "") {
                    setDadoFinanceiro({
                      ...dadoFinanceiro,
                      segundaInstrucaoBancaria: undefined,
                    });
                  } else {
                    const selectedInstrucao = instrucaoBancaria.find(
                      (instrucao) => instrucao.id === parseInt(e.target.value)
                    );
                    if (selectedInstrucao) {
                      setDadoFinanceiro({
                        ...dadoFinanceiro,
                        segundaInstrucaoBancaria: selectedInstrucao,
                      });
                    }
                  }
                }}
                disabled={(!isEdited && !!dadoFinanceiroToEdit) || isRequest}
                options={instrucaoBancaria.map((instrucao) => ({
                  value: (instrucao.id ?? "").toString(),
                  label: instrucao.tipoInstrucao,
                }))}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <Label htmlFor="terceiraInstrucaoBancaria">
                Terceira Instrução bancária
              </Label>
              <SelectComponent
                color="black"
                placeholder="Nenhuma instrução bancária"
                isPlaceHolder={!isEdited}
                id="terceiraInstrucaoBancaria"
                width={Number("100%")}
                name="terceiraInstrucaoBancaria"
                value={
                  dadoFinanceiro.terceiraInstrucaoBancaria?.id
                    ? dadoFinanceiro.terceiraInstrucaoBancaria.id.toString()
                    : ""
                }
                onChange={(e) => {
                  if (e.target.value === "") {
                    setDadoFinanceiro({
                      ...dadoFinanceiro,
                      terceiraInstrucaoBancaria: undefined,
                    });
                  } else {
                    const selectedInstrucao = instrucaoBancaria.find(
                      (instrucao) => instrucao.id === parseInt(e.target.value)
                    );
                    if (selectedInstrucao) {
                      setDadoFinanceiro({
                        ...dadoFinanceiro,
                        terceiraInstrucaoBancaria: selectedInstrucao,
                      });
                    }
                  }
                }}
                disabled={(!isEdited && !!dadoFinanceiroToEdit) || isRequest}
                options={instrucaoBancaria.map((instrucao) => ({
                  value: (instrucao.id ?? "").toString(),
                  label: instrucao.tipoInstrucao,
                }))}
              />
            </Col>
            <Col>
              <Label htmlFor="quartaInstrucaoBancaria">
                Quarta Instrução bancária
              </Label>
              <SelectComponent
                color="black"
                placeholder="Nenhuma instrução bancária"
                isPlaceHolder={!isEdited}
                id="quartaInstrucaoBancaria"
                width={Number("100%")}
                name="quartaInstrucaoBancaria"
                value={
                  dadoFinanceiro.quartaInstrucaoBancaria?.id
                    ? dadoFinanceiro.quartaInstrucaoBancaria.id.toString()
                    : ""
                }
                onChange={(e) => {
                  if (e.target.value === "") {
                    setDadoFinanceiro({
                      ...dadoFinanceiro,
                      quartaInstrucaoBancaria: undefined,
                    });
                  } else {
                    const selectedInstrucao = instrucaoBancaria.find(
                      (instrucao) => instrucao.id === parseInt(e.target.value)
                    );
                    if (selectedInstrucao) {
                      setDadoFinanceiro({
                        ...dadoFinanceiro,
                        quartaInstrucaoBancaria: selectedInstrucao,
                      });
                    }
                  }
                }}
                disabled={(!isEdited && !!dadoFinanceiroToEdit) || isRequest}
                options={instrucaoBancaria.map((instrucao) => ({
                  value: (instrucao.id ?? "").toString(),
                  label: instrucao.tipoInstrucao,
                }))}
              />
            </Col>
          </Row> */}
          <Row>
            <Col>
              <Label htmlFor="observacao">Observações</Label>
              <TextAreaObservacao
                name="observacao"
                id="observacao"
                value={dadoFinanceiro.observacao ?? ""}
                onChange={(e) =>
                  setDadoFinanceiro({
                    ...dadoFinanceiro,
                    observacao: e.target.value,
                  })
                }
                placeholder="descreva a observação"
                disabled={(!isEdited && !!dadoFinanceiroToEdit) || isRequest}
                dados-financeiros-rows={3}
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          {editOnly &&
          contribuinteData.LastMovimentacao?.tipo !== "EXCLUSAO" ? (
            <Button
              type="button"
              schemaButton={
                dadoFinanceiroToEdit
                  ? !isEdited
                    ? "full-secondary"
                    : "full-primary"
                  : "full-primary"
              }
              action={() =>
                dadoFinanceiroToEdit
                  ? !isEdited
                    ? setIsEdited(true)
                    : handleSave()
                  : handleSave()
              }
            >
              {dadoFinanceiroToEdit
                ? !isEdited
                  ? "Editar"
                  : "Salvar edição"
                : "Salvar"}
            </Button>
          ) : (
            <div></div>
          )}
          <Button
            type="button"
            schemaButton={"full-danger"}
            action={() => (isEdited ? loadDataEdit() : clearFieldsAndClose())}
          >
            {isEdited ? "Cancelar edição" : "Fechar"}
          </Button>
          {/* <Button schemaButton="out-primary" action={() => {}}>
              Imprimir boletos
            </Button> */}
        </ModalFooter>
      </ModalContent>
    </ModalContainer>
  );
};

export default DadosFinanceirosModal;
